export default {
  name: 'AgentsOrNumbersCardSwitchLayout',

  data() {
    return {
      activeTab: 'numbers',
    };
  },
};
